import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { attachmentStatuses, attachmentStatusTypeMap } from '../../util/attachmentConsts'
import { theme } from '../../themes/theme'
import { BoldMedBodyText } from '../styles/Text'

const bgColor = {
  drafting: 'rgba(58, 58, 58, 0.10)',
  awaitingApproval: 'rgba(208, 198, 16, 0.10)',
  readyToSend: 'rgba(16, 208, 112, 0.10)'
}

const borderColor = {
  drafting: 'rgba(58, 58, 58, 1)',
  awaitingApproval: 'rgba(208, 198, 16, 1)',
  readyToSend: 'rgba(16, 208, 112, 1)'
}

const Background = styled.div`
  display: flex;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;

  color: #333;
  border: ${props => `1px solid ${borderColor[props.status]}`};
  background-color: ${props => bgColor[props.status]};
  border-radius: ${theme.borderRadius.button};
  padding: ${props => (props.type === 'default' ? '8px 15px' : '4px 8px')};
`

const WhiteBackground = styled(Background)`
  padding: 0;
  background-color: #fff;
`

const Status = styled(BoldMedBodyText)`
  text-align: inherit;
  text-transform: capitalize;
`

function AttachmentStatus({ status, style = 'default' }) {
  const statusInfo = attachmentStatusTypeMap[status]

  return (
    <WhiteBackground>
      <Background status={statusInfo.type} type={style}>
        <Status>{statusInfo.label}</Status>
      </Background>
    </WhiteBackground>
  )
}

AttachmentStatus.propTypes = {
  status: PropTypes.oneOf(attachmentStatuses).isRequired,
  style: PropTypes.oneOf(['default', 'small'])
}

export default AttachmentStatus
